import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

/** Sculpt Spells (Evoker 6): choose who the area spell leaves alone. Allies start chosen, up to the limit. */
export default function SculptSpellsPrompt({ spellName, limit, creatures, onDone }) {
  const [chosen, setChosen] = useState(() => creatures.filter((creature) => !creature.hostile).map((creature) => creature.id).slice(0, limit));
  const everyone = chosen.length >= creatures.length;
  const toggle = (id) => setChosen((list) => (list.includes(id) ? list.filter((entry) => entry !== id) : [...list, id]));
  return <Modal className="dnd-modal" centered show animation={false} onHide={() => onDone([])} aria-labelledby="sculpt-spells-title">
    <Modal.Header closeButton closeLabel="Close" closeVariant="white"><Modal.Title id="sculpt-spells-title">Sculpt Spells</Modal.Title></Modal.Header>
    <Modal.Body>
      <p>{spellName}: choose up to {limit} creatures you can see. They succeed on the save and take no damage.</p>
      {creatures.map((creature) => <Form.Check key={creature.id} id={`sculpt-${creature.id}`} label={`${creature.name}${creature.hostile ? ' · hostile' : ''}`} checked={chosen.includes(creature.id)}
        disabled={!chosen.includes(creature.id) && chosen.length >= limit} onChange={() => toggle(creature.id)}/>)}
    </Modal.Body>
    <Modal.Footer>
      {everyone && <span className="small me-auto">Leave at least one creature in the spell.</span>}
      <Button disabled={everyone} onClick={() => onDone(chosen)}>Cast {chosen.length ? `sparing ${chosen.length}` : 'on everyone'}</Button>
    </Modal.Footer>
  </Modal>;
}
